import { createContext } from "react";

import { AvailablePlatform } from "@/types/availablePlatform.types";
import { PlatformId } from "@/types/platform.types";
import { noop } from "@/utils/function.utils";

export type CurrentPlatformContextValueType = {
  platform: AvailablePlatform | null;
  accessiblePlatformsCount: number;
  availablePlatformsCount: number;
  loading: boolean;
  isInitialized: boolean;
  switchPlatform: (platformId: PlatformId) => void;
  /**
   * Reads-and-clears whether the most recent platform change was an intentional
   * `switchPlatform` call (sidebar-style switch) rather than a direct URL
   * navigation. The organization context uses this to decide whether to reset the
   * current org to the new platform's data-owner: only intentional switches reset,
   * so deep links / scoped navigations that carry an explicit entity are honored.
   */
  consumePlatformSwitchIntent: () => boolean;
  refetch: () => Promise<unknown>;
  isError: boolean;
};

export const CurrentPlatformContext = createContext<CurrentPlatformContextValueType>({
  accessiblePlatformsCount: 0,
  availablePlatformsCount: 0,
  platform: null,
  loading: false,
  isInitialized: false,
  switchPlatform: noop,
  consumePlatformSwitchIntent: () => false,
  refetch: () => Promise.resolve(),
  isError: false,
});
